import { getConfigBusinessInfo } from 'src/utils/firebase/firebase-short-cut';
import useSWRImmutable from 'swr/immutable';

const useBusinessInfo = () => {
  const { data: businessInfo, isValidating } = useSWRImmutable('config/business-info', getConfigBusinessInfo);

  return {
    businessInfo,
    isValidating,
  };
};

export default useBusinessInfo;
